// Carga.tsx
import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface CargaProps {
    isLoading: boolean;
}

const Carga: React.FC<CargaProps> = ({ isLoading }) => {
    return (
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 999,
            }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default Carga;
